import css from 'styled-jsx/css'
export default function getStyle(isVisible)
{
  return css.resolve`
    .discount-input {
      display: inline-flex;
      flex: 1;
      flex-direction: row;
      align-items: center;
      max-width: calc(100vw - 50px);
      border: 1px solid rgba(var(--accentColorMedium), 1);
      border-radius: ${isVisible ? "5px 20px 20px 5px" : "0px"};
      overflow: ${isVisible ? "hidden" : "auto"};
      border-width: ${isVisible ? "1px" : "0px"};
    }

    .discount-input.active {
      outline: none;
      box-shadow: 0 0px 0px 2px rgba(var(--accentColorMedium), 1);
      border-color: rgba(var(--accentColor), 1);
    }

    .discount-input.error {
      border-color: rgba(var(--errorColor), 0.5);
    }

    .discount-input.error.active {
      box-shadow: 0 0px 0px 2px rgba(var(--errorColor), 0.5);
        border-color: rgba(var(--errorColor), 1);
    }

    .discount-input.filled {
      border: 0;
      border-radius: 0px;
      overflow: auto;
      font-size: 15px;
      font-weight: 300;
    }

    .discount-input.filled :global(.icon-button-icon) {
      padding-left: 5px;
      padding-right: 5px;
    }

    .discount-input.filled :global(svg) {
      width: 8px;
    }

    .discount-input .link {
      display: ${isVisible ? "none": "flex"};
      justify-self: center;
      width: 100%;
      cursor: pointer;
      color: rgba(var(--accentColorDark), 1);
      text-decoration: underline;
    }

    .discount-input input {
      display: ${isVisible ? "block" : "none"};
      height: 34px;
      border: 0;
      border-radius: 0;
      outline: none;
      box-shadow: none;
      border-right: 1px solid rgba(var(--accentColorMedium), 1);
      text-transform: uppercase;
      flex: 1;
    }

    .discount-input input::-webkit-input-placeholder {
      text-align: center;
    }

    .discount-input input:-moz-placeholder {
      text-align: center;
    }

    .discount-input input::-moz-placeholder {
      text-align: center;
    }

    .discount-input input:-ms-input-placeholder {
      text-align: center;
    }

    .discount-input :global(button.discount-apply) {
      display: ${isVisible ? "block" : "none"};
      border: 0;
      border-radius: 0;
      outline: none;
      box-shadow: none;
      line-height: 20px;
      min-width: 120px;
      background-color: rgba(var(--accentColorLightest), 1);
    }

    @media (min-width: 570px) {
      .discount-input {
        border-radius: 5px 20px 20px 5px;
        overflow: hidden;
        border-width: 1px;
      }
      .discount-input input {
        display: block;
      }
      .discount-input .link {
        display: none;
      }
      .discount-input :global(button.discount-apply) {
        display: block;
      }
    }
  `;
}